import { render, staticRenderFns } from "./ExtendClose.vue?vue&type=template&id=458d5435&scoped=true"
import script from "./ExtendClose.vue?vue&type=script&lang=js"
export * from "./ExtendClose.vue?vue&type=script&lang=js"
import style0 from "./ExtendClose.vue?vue&type=style&index=0&id=458d5435&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458d5435",
  null
  
)

export default component.exports